var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeluid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.3 35.3",
    style: {
      enableBackground: "new 0 0 35.3 35.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#33ADA3;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F28F39;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#E8553F;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#E8553F;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,10.1H5c-0.8,0-1.5,0.7-1.5,1.5v12.2c0,0.8,0.7,1.5,1.5,1.5h5.1V10.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.8,17.6c0-2.3-1.8-4.1-4.1-4.1v8.3C26,21.8,27.8,19.9,27.8,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,25.8v4c0,1.5-1.7,2.5-3,1.7l-10.6-6.3V10.1l10.6-6.3c1.3-0.8,3,0.2,3,1.7v4V25.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,25.5c3.5-0.9,6.1-4.1,6.1-7.9c0-3.8-2.6-7-6.1-7.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeluid);
export default __webpack_public_path__ + "static/media/geluid.0962e4ab1350047084937f6b77f6d0bf.svg";
export { ForwardRef as ReactComponent };